import { Text } from '@thanx/uikit/text'
import powerCircle from 'assets/images/home/img_powerCircle.svg'
import { useOrderingAccess } from 'hooks/useOrderingAccess'
import { useReportPermission } from 'hooks/useReportPermission'
import { buildTranslate } from 'locales'
import { Fields as Merchant } from 'models/Merchant'
import React from 'react'
import { Col, Row } from 'react-bootstrap-five'
import { useAbility } from 'utilities/ability'
import ActivationRateMetric from './MetricCards/ActivationRateMetric'
import CaptureRateMetric from './MetricCards/CaptureRateMetric'
import EffectiveDiscountRateMetric from './MetricCards/EffectiveDiscountRateMetric'
import OrderSatisfactionMetric from './MetricCards/OrderSatisfactionMetric'
import RetentionRateMetric from './MetricCards/RetentionRateMetric'

const t = buildTranslate('home.metrics')

type MetricsT = {
  merchant: Merchant
}

const Metrics: React.FC<MetricsT> = ({ merchant }) => {
  // CTA pushes to /order_feedback (OrderSatisfactionMetric.tsx), whose own
  // gate is an OR of Feedback and LocationReports/NpsReports — mirror that
  // here so the card and the OC nav link (Navbar/OperationsCenter/Content.tsx)
  // agree on who can reach it. Also requires ordering capability: a merchant
  // with no ordering provider can never generate a rate, so skip the
  // permanently-empty card for them.
  const { resource, action } = useReportPermission({
    rbac: 'LocationReports',
    legacy: 'NpsReports',
  })
  const ability = useAbility()
  const canViewFeedbackReport =
    ability.can(action, resource) || ability.can('access', 'Feedback')
  const { supportsOrderingProvider } = useOrderingAccess()

  return (
    <div className="mt-xl mb-xxxl">
      <Row>
        <Col className="text-center">
          <img className="mb-xs" src={powerCircle} alt="performance" />
          <Text.Header2 className="mt-0" color="grey90">
            {t('title')}
          </Text.Header2>
        </Col>
      </Row>
      {supportsOrderingProvider && canViewFeedbackReport && (
        <Row className="mt-l">
          <OrderSatisfactionMetric merchant={merchant} />
        </Row>
      )}
      <Row className="mt-l row-eq-height">
        <CaptureRateMetric merchant={merchant} />
        <ActivationRateMetric merchant={merchant} />
        <RetentionRateMetric merchant={merchant} />
        <EffectiveDiscountRateMetric merchant={merchant} />
      </Row>
    </div>
  )
}

export default Metrics
